import api from "../../services/api"
import { KANBAN_SITUACOES_QUERY_KEY, FLUXO_MOTIVOS_QUERY_KEY } from "../kanbanFluxoQueryKeys"
import { useSituacaoStore } from "../../stores/situacaoStore"
import { N_STALE_METADADOS_MS } from "../../constants/timing"

/** Pré-carrega metadados e chunks do board para reduzir TTI do Kanban/Fluxo. */
export const prefetchKanbanBoardMetadados = (queryClient) => {
  if (!queryClient) return

  queryClient.prefetchQuery(
    KANBAN_SITUACOES_QUERY_KEY,
    async () => useSituacaoStore.getState().listaSimplesObter(),
    { staleTime: N_STALE_METADADOS_MS },
  )

  queryClient.prefetchQuery(
    FLUXO_MOTIVOS_QUERY_KEY,
    async () => {
      const { data } = await api.get("/motivos-contato/list")
      return data || []
    },
    { staleTime: N_STALE_METADADOS_MS },
  )
}

/** Pré-carrega bundles pesados do trello/card (webpack prefetch). */
export const prefetchKanbanBoardBundles = () => {
  import(/* webpackPrefetch: true */ "react-trello")
  import(/* webpackPrefetch: true */ "../../components/CustomCard")
}

/** Chunks das telas Kanban/Fluxo + board (baixa prioridade de rede). */
export const prefetchPacotesKanbanFluxo = (lIncluirFluxo = true) => {
  prefetchKanbanBoardBundles()
  import(/* webpackPrefetch: true */ "../../pages/Kanban")
  import(/* webpackPrefetch: true */ "../../components/TrelloBoardMemo")
  if (lIncluirFluxo) {
    import(/* webpackPrefetch: true */ "../../pages/Fluxo de Conversas")
  }
}

export const prefetchKanbanBoardCompleto = (queryClient, lIncluirFluxo = true) => {
  prefetchPacotesKanbanFluxo(lIncluirFluxo)
  prefetchKanbanBoardMetadados(queryClient)
}
